module.exports = __webpack_public_path__ + "media/dogs/dogs-meeting-54d16853.svg";